module.exports = {"version":"3.43.3","name":"骑手配送系统","entryTitles":{"index":"首页","login":"登录"},"port":4002,"useDevProxy":true,"devUrl":"https://candao-dmscd3-qc.can-dao.com/","useLoading":true}


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/build.config.json
// module id = 107
// module chunks = 96 97 98 99